import script from "./CarTarMan.vue?vue&type=script&lang=ts&setup=true"
export * from "./CarTarMan.vue?vue&type=script&lang=ts&setup=true"

import "./CarTarMan.vue?vue&type=style&index=0&id=10efa770&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10efa770"]])

export default __exports__